import { UnknownError } from '@cian/peperrors/shared';

import { TAddOfferToComparisonResponse } from 'shared/repositories/offers-comparison/v1/add-offer-to-comparison';
import { getErrorMessage } from 'shared/utils/getErrorMessage';

export const assertUnknownError = (response: TAddOfferToComparisonResponse): void => {
  if (response.statusCode !== 400) {
    return;
  }

  const { message, errors } = response.response;

  throw new UnknownError({
    domain: 'src/shared/services/offersComparison/addOfferToComparison.ts',
    message: getErrorMessage(message),
    details: {
      errors: typeof errors === 'object' && JSON.stringify(errors),
    },
  });
};
